import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { OverlayTrigger } from 'react-bootstrap';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookFuelCheckTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          fuel_check_ok: false,
          fuel_check_na: false,
          approvals: [],
          approval: [],
          modal_justification: false,
        };
        this.edit = this.edit.bind(this);
        this.reopen = this.reopen.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }

      // Envia seleção OK/N/A do Fuel Check
      edit(datasave) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/fuel-check', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (typeof self.props.updateData === 'function') {
              self.props.updateData(responseJson);
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      handleCheckboxOkChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            fuel_check_ok: false,
            fuel_check_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            fuel_check_ok: false,
            fuel_check_na: false,
          };
        } else {
          this.setState({
            fuel_check_ok: true,
            fuel_check_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            fuel_check_ok: true,
            fuel_check_na: false,
          };
        }
        this.edit(datasave);
      }
      handleCheckboxNaChange(name, event) {
        if(event.target.checked === false) {
          this.setState({
            fuel_check_ok: false,
            fuel_check_na: false,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            fuel_check_ok: false,
            fuel_check_na: false,
          };
        } else {
          this.setState({
            fuel_check_ok: false,
            fuel_check_na: true,
          });
          var datasave = {
            aircraft_logbook_id: this.state.aircraft_logbook_id,
            fuel_check_ok: false,
            fuel_check_na: true,
          };
        }
        this.edit(datasave);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        // Popular estado do checkbox (OK/N/A) quando vier pelas props
        if (typeof newProps.fuel_check_ok !== 'undefined' || typeof newProps.fuel_check_na !== 'undefined') {
          this.setState({
            fuel_check_ok: !!newProps.fuel_check_ok,
            fuel_check_na: !!newProps.fuel_check_na,
          });
        }

        if(typeof newProps.approvals[1] !== 'undefined' && newProps.approvals[1] !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[1],
            approval: newProps.approvals[1][0],
          });
        }
      }

      reopen(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var datasave = {
          id: this.state.approval.id,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          justification: this.state.justification,
        };
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/aprovacao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({ modal_justification: false, justification: null });
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
      <div className="row">
        <div className="col-md-1 text-center">
          {
            (self.state.approval.status === 1) ?
              <button onClick={() => self.setState({ modal_justification: true })} className="btn btn-primary"><i className="fa fa-fw fa-refresh"></i></button>
            :
              <button onClick={() => {self.props.approve(self.state.approval.id, self.state.approval.type)}} className="btn btn-success"><i className="fa fa-check"></i></button>
          }
        </div>
        <div className="col-md-4">
          <h3 className="page-title pull-left">Fuel Check</h3>
          <div className="clearfix"></div>
        </div>
        <div className="col-md-3">
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Clear, Bright, No Water or Sediments</label>
                  <br></br>
                  <label>
                    <input
                      name="fuel_check_ok"
                      type="checkbox"
                      checked={this.state.fuel_check_ok}
                      onChange={this.handleCheckboxOkChange.bind(this, 'fuel_check_ok')} 
                    />
                    &nbsp;OK
                  </label>
                  &nbsp;
                  <label>
                    <input
                      name="fuel_check_na"
                      type="checkbox"
                      checked={this.state.fuel_check_na}
                      onChange={this.handleCheckboxNaChange.bind(this, 'fuel_check_na')} 
                    />
                    &nbsp;N/A
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <caption>Approval</caption>
              <thead>
                <tr className="text-center">
                  <th>User</th>
                  <th>Status</th>
                  <th>Approval Date</th>
                </tr>
              </thead>
              <tbody id="fuel_check_approvals">
              {self.state.approvals.map(function(k) {
                  var approval = k;
                  return(
                    <tr className="text-center" key={approval.id}>
                      {
                        (typeof approval.user_id !== 'undefined' && approval.user_id !== null) ?
                        <td>{approval.user_name}</td>
                        :
                        <td></td>
                      }
                      <td>{approval.status_str}</td>
                      <td>{approval.approval_date_str}</td>
                    </tr>
                  );
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr/>
      {/* Modal de justificativa para reabertura */}
      <Modal show={this.state.modal_justification} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left"><strong>Please tell us why you need to reopen this fuel check</strong></h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}><i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <p className="alert alert-danger">Attention: This reopening should only be used in case of filling errors. For a new fuel check after changing the aircraft's conditions, please open a new logbook.</p>
          <form onSubmit={this.reopen}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Justification:</label>
                  <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> Submit justification</button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default AircraftLogbookFuelCheckTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookFuelCheckTab.js